module.exports = __webpack_public_path__ + "aa4f9349231875980ec89654a5c5241c.svg";